import React from "react";
import {useState,useEffect,useRef } from 'react';
import { LineChart,BarChart,AreaChart,Rectangle,Bar, Line,Area, XAxis, YAxis, CartesianGrid, Tooltip, 
  Legend, ResponsiveContainer, Cell, ReferenceLine, PieChart,Pie,LabelList } from "recharts";
import axios from "axios";
import configData from "../config.json";
import {Link} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { useReactToPrint } from 'react-to-print';
import { monthList } from '../utils/datalist';
import GrowthChart from '../components/GrowthChart';
import { COLOR } from "rsuite/esm/internals/constants";
import {ProSalesProfitGraph} from '../components';


const ProSalesProfitAnalysis=()=>{
      const [misData,setMisData]=useState([]);
      const [misDataSum,setMisDataSum]=useState([]);
      const [aMonth, setMonth] = useState(6);
      const [aYear, setYear] = useState(2025);
      const [loading, setLoading] = useState(false);
      const [activeCell,setActiveCell]=useState("");
      const [maxHeight,setMaxHeight]=useState('600px');


      const COLORS = ['#FFBB28', '#FF8042','#f02390ff','#0b9118ff','#0088FE', '#00C49F' ];

    useEffect(() => {
      const getMisData = async () => {
        const response=await axios.get(configData.SERVER_URL+`/bsecmisDashboard/${localStorage.getItem('branchID')}`)
        setMisData(response.data);
      };
      getMisData();

    }, []);

    const handleSubmit=async(e)=>{
      e.preventDefault();
      setLoading(true);
      try {
        const response = await axios.get(configData.SERVER_URL+`/misDataSum/${aYear}/${aMonth}/${localStorage.getItem('branchID')}`);
        setMisDataSum(response.data);
      } catch (error) {
        console.error('Search error:', error);
      }   
      setLoading(false);
    }


    const totals = misDataSum.reduce((acc, item) => {
      
      acc.monthlyProValue += Number(item.proValue) || 0;
      acc.totalCumProValue += Number(item.cumProValue) || 0;
      acc.totalCumPreProValue += Number(item.cumPreProValue) || 0;

      acc.monthlySalesValue += Number(item.salesValue) || 0;
      acc.totalCumSalesValue += Number(item.cumSalesValue) || 0;
      acc.totalCumPreSalesValue += Number(item.cumPreSalesValue) || 0;

      acc.monthlyProfitLoss += Number(item.profitLoss) || 0;
      acc.totalCumProfitLoss += Number(item.cumProfitLoss) || 0;
      acc.totalCumPreProfitLoss += Number(item.cumPreProfitLoss) || 0;

      acc.monthlyProfitTarget+=Number(item.profitMT) || 0;
      acc.totalCumProfitTarget+=Number(item.profitCumMT) || 0;

      acc.monthlyProTargetValue+=Number(item.proMtValue) || 0;
      acc.totalProTargetValue+=Number(item.cumProMtValue) || 0;

      acc.monthlySalesTargetValue+=Number(item.mtValue) || 0;
      acc.totalSalesTargetValue+=Number(item.cumMtValue) || 0;

      acc.totalproTargetValue+=Number(item.proTargetValue) || 0;
      acc.totaltargetValue+=Number(item.targetValue) || 0;
      acc.totalprofitTarget+=Number(item.profitTarget) || 0;

      acc.totalpreProTargetValue+=Number(item.preProTargetValue) || 0;
      acc.totalpreTargetValue+=Number(item.preTargetValue) || 0;
      acc.totalpreProfitTarget+=Number(item.preProfitTarget) || 0;

      acc.totalpreCumProTargetValue+=Number(item.preCumProTargetValue) || 0;
      acc.totalpreCumTargetValue+=Number(item.preCumTargetValue) || 0;
      acc.totalpreProfitCumTarget+=Number(item.preProfitCumTarget) || 0;
      return acc;
    },
    { monthlyProValue:0, totalCumProValue: 0, totalCumPreProValue: 0, 
      monthlySalesValue:0, totalCumSalesValue: 0, totalCumPreSalesValue: 0,
      monthlyProfitLoss:0, totalCumProfitLoss: 0, totalCumPreProfitLoss: 0,
      monthlyProfitTarget:0, totalCumProfitTarget:0,
      monthlyProTargetValue:0, totalProTargetValue:0,
      monthlySalesTargetValue:0, totalSalesTargetValue:0,
      totalproTargetValue:0, totaltargetValue:0,totalprofitTarget:0,
      totalpreProTargetValue:0, totalpreTargetValue:0, totalpreProfitTarget:0,
      totalpreCumProTargetValue:0, totalpreCumTargetValue:0, totalpreProfitCumTarget:0,
     }
    );
    
    const getMonthName = (id) => {
      return monthList.find(m => m.id === Number(id))?.name || "not";
    };

    const printDiv_production = async(printDiv) => {
        await setMaxHeight('auto');
        const printElement = document.getElementById(printDiv);
        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    <div class="row well">
                      <h2 style={{ margin: 0 }}> Production, Sales & Profit-Loss Analysis</h2>
                      <small style={{ color: "#6c757d" }}> Current Year vs Previous Year with Cumulative Data </small>
                    </div>
                     ${printElement.innerHTML}
                </body>
            </html>
        `);

        await setMaxHeight('600px');

        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
        
    };

  const getProfitComment = (curr, prev, diff) => {

  // Profit → Profit
  if (Number(prev) > 0 && Number(curr) > 0) {
    // return curr > prev ? 'Profit Increased'+curr+'->'+prev : 'Profit Decreased';
    return Number(curr) > Number(prev) ? 'Profit Increased' : 'Profit Decreased';
  }
  // Loss → Profit (Turnaround)
  if (Number(prev) < 0 && Number(curr) > 0) {
    return 'Excellent Turnaround From Loss to Profit';
  }
  // Profit → Loss (Negative Turnaround)
  if (Number(prev) > 0 && Number(curr) < 0) {
    return 'Strong Negative Turnaround From Profit to Loss';
  }
  // Loss → Loss
  if (Number(prev) < 0 && Number(curr) < 0) {
    return Number(diff) < 0 ? `Loss Increased`: `Loss Decreased but in Loss`;
  }
  return 'No Comments';
  };

    return(
        <>
        <div >                       
            <div className="card text-black bg-info o-hidden h-100" >
                <div className="card-header">
                  {/* {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Processing...
                  </>
                  ) : (
                    "Monthly MIS Data Analysis"
                  )} */}

                    <div className="row well">
                    <h2 style={{ margin: 0 }}> Production, Sales & Profit-Loss Analysis</h2>
           
                    <small style={{ color: "#6c757d" }}> Current Year vs Previous Year with Cumulative Data </small>
                    </div>

                  <div className="row well" >
                    <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                      <label>Financial Year</label>
                      <input type="number" class="form-control" id="aYear" name="aYear" value={aYear} onChange={(e)=>{setYear(e.target.value);}}></input>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                      <label>Month</label>
                      <select className="form-select col-lg-2 col-md-4 col-xs-6" id="monthName" name="monthName" onChange={(e)=>{setMonth(e.target.value);}}  value={aMonth} required>
                      {monthList.map(month => (
                        <option key={month.id} value={month.id}>{month.name}</option>
                      ))}   
                      </select>
                    </div>
                    <div className="col-lg-2">
                        <br />
                        <button type="button" className="btn btn-success me-2"
                            onClick={(e) => handleSubmit(e)} >
                            <Icon.Search />
                        </button>

                        {/* <button type="button" className="btn btn-success me-2"
                            onClick={(e) => handleHeight(e)} >
                            <Icon.TextareaResize />
                        </button> */}

                        <button type="button" className="btn btn-warning"
                            onClick={() => printDiv_production("print_production")}>
                            <Icon.Printer />
                        </button>
                    </div>
                  </div>
                </div>

                <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "0px", borderRadius: "10px" }} id="print_production">
                  {
                    misDataSum && misDataSum.length >0 &&(
                      <>
                      <div className="card text-white bg-info o-hidden h-100"  >                     
                        <div className="card-header">
                          
                        </div>
                        <div className="card-body"  style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px" }}>
                        <div className="table-responsive table-container" style={{ height: maxHeight }} >
                        <table className="table table-bordered table-hover align-middle text-center  mis-table" style={{fontSize:'14px'}}>
                        <thead className="table-primary">
                          <tr style={{ border: '1px solid black'}}>
                            <th rowSpan={2}>Org.</th>
                            <th rowSpan={2}>Particulars</th>
                            <th colspan={3} className="align-top">Target (Qty/Value)</th> 
                            <th colspan={4} className="align-top">Financial Year {aYear}-{Number(aYear)+1}<br></br>(For the month {getMonthName(aMonth)},{ aMonth<=6 ? Number(aYear)+1 : Number(aYear)})</th>
                            <th colspan={3} className="align-top" style={{backgroundColor:'pink'}} >Financial Year {Number(aYear)-1}-{Number(aYear)}<br></br>(For the month {getMonthName(aMonth)},{ aMonth<=6 ? Number(aYear) : Number(aYear)-1})</th> 
                            <th rowSpan={2}>Diff.<br></br>Qty/Value</th>
                            <th rowSpan={2}>Growth (% on Value)</th>
                          </tr>
                          <tr style={{ border: '1px solid black'}}>
                            <th>Yearly</th>  
                            <th>Monthly</th>
                            <th>Cum.</th>

                            <th>Monthly<br></br>Qty/Value</th>
                            <th>Cum.<br></br>Qty/Value</th>
                            <th>Monthly<br></br> Achi.(Qty)</th>
                            <th>Cum.<br></br> Achi.(Qty)</th>

                            <th>Target<br></br>Qty/Value</th>
                            <th>Cum.<br></br>Qty/Value</th>
                            <th>Achie. (Qty)</th>
                          </tr>  
                        </thead>
                        <tbody>
                          {                            
                          misDataSum && misDataSum.length>0 && misDataSum.map((data,index)=>(
                            <React.Fragment key={index}>
                            <tr style={{ border: '1px solid black'}}>
                              <td rowSpan={3} >{data.branchcode}<br></br><Link to= {"/home/misReport/"+data.branchID+"/"+data.fYear} ><Icon.EyeFill size={20}/></Link></td>
                              <td>Production<br/>({data.units})</td>
                              
                              <td>{Number(data.proTargetQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.proTargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.proMtQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.proMtValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.cumProMtQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.cumProMtValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{data.proQty!== null ? Number(data.proQty):'0.00'}<hr></hr>{data.proValue!== null ? Number(data.proValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td>{Number(data.cumProQty)}<hr></hr>{data.cumProValue!== null ? Number(data.cumProValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td>{(data.proQty>0 && data.proMtQty>0) ? ((Number(data.proQty)/Number(data.proMtQty))*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              <td>{(data.cumProQty>0 && data.cumProMtQty) ? ((Number(data.cumProQty)/Number(data.cumProMtQty))*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              
                              <td style={{backgroundColor:'pink'}}>{Number(data.preProTargetQty)}<hr></hr>{data.preProTargetValue!== null ? Number(data.preProTargetValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{Number(data.cumPreProQty)}<hr></hr>{data.cumPreProValue!== null ? Number(data.cumPreProValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{(data.cumPreProQty>0 && data.preProTargetQty>0) ? Number((data.cumPreProQty/((data.preProTargetQty/12)*data.fMonth))*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              
                              <td>{(data.cumProQty-data.cumPreProQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.diffProductionGrowth).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.productionGrowth).toFixed(2).toLocaleString('en-IN')} % {(data.diffProductionGrowth>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                            </tr>

                            <tr className="shaded-row" style={{ border: '1px solid black'}}>                             
                              <td>Sales<br/>({data.units})</td>

                              <td>{Number(data.targetQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.targetValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.mtQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.mtValue).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.cumMtQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.cumMtValue).toFixed(2).toLocaleString('en-IN')}</td>
                              
                              <td>{data.salesQty!== null ? Number(data.salesQty):'0.00'}<hr></hr>{data.salesValue!== null ? Number(data.salesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td>{Number(data.cumSalesQty)}<hr></hr>{data.cumSalesValue!== null ? Number(data.cumSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td>{(data.salesQty>0 && data.mtQty>0) ? Number((data.salesQty/data.mtQty)*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              <td>{(data.cumSalesQty>0 && data.cumMtQty) ? Number((data.cumSalesQty/data.cumMtQty)*100).toFixed(2).toLocaleString('en-IN'):'0.00'}%</td>
                              
                              <td style={{backgroundColor:'pink'}}>{Number(data.preTargetQty)}<hr></hr>{data.preTargetValue!== null ? Number(data.preTargetValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{Number(data.cumPreSalesQty)}<hr></hr>{data.cumPreSalesValue!== null ? Number(data.cumPreSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{(data.preTargetQty>0 && data.cumPreSalesQty>0) ? Number((data.cumPreSalesQty/((data.preTargetQty/12)*data.fMonth))*100).toFixed(2):'0'} % </td>
                              
                              <td>{Number(data.cumSalesQty-data.cumPreSalesQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.diffSalesGrowth).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.salesGrowth).toFixed(2).toLocaleString('en-IN')} %{(data.diffSalesGrowth>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                            </tr>

                            <tr style={{ border: '1px solid black'}}>                           
                              <td>Profit/Loss<br/>(Lac)</td>
                              <td>{Number(data.profitTarget).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.profitMT).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{Number(data.profitCumMT).toFixed(2).toLocaleString('en-IN')}</td>
                              <td>{data.profitLoss!== null ? data.profitLoss:'0.00'}</td>
                              <td>{data.cumProfitLoss!== null ? data.cumProfitLoss:'0.00'}</td>
                              <td>{Number(data.profitMT)>0 ? (Number((data.profitLoss/data.profitMT)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
                              <td>{Number(data.profitCumMT)>0 ? (Number((data.cumProfitLoss/data.profitCumMT)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>

                              <td style={{backgroundColor:'pink'}}>{Number(data.preProfitTarget).toFixed(2).toLocaleString('en-IN')}</td>
                              <td style={{backgroundColor:'pink'}}>{data.cumPreProfitLoss!== null ? Number(data.cumPreProfitLoss).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                              <td style={{backgroundColor:'pink'}}>{(Number(data.preProfitCumTarget)>0) ? (Number((data.cumPreProfitLoss/data.preProfitCumTarget)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
 
                              <td>{Number(data.diffProfitGrowth).toFixed(2).toLocaleString('en-IN')}</td>
                              
                              <td>
                                {/* {Number(data.profitGrowth).toFixed(2).toLocaleString('en-IN')} % */}
                                {(data.diffProfitGrowth>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}
                                <br></br>
                                {getProfitComment(data.cumProfitLoss, data.cumPreProfitLoss,data.diffProfitGrowth)}
                              </td>
                            </tr>

                            <tr><td colspan={14} style={{backgroundColor:'lightgreen'}}></td></tr>
                            </React.Fragment>
                          ))}
                          <tr style={{ border: '1px solid black'}}>
                            <td rowSpan={3} >Total<br></br>(Amount in Lac)</td>
                            <td>Production</td>
                            <td>{Number(totals.totalproTargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.monthlyProTargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalProTargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.monthlyProValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalCumProValue).toFixed(2).toLocaleString('en-IN')}</td>
                    
                            <td>{Number(totals.monthlyProTargetValue)>0 ? (Number((totals.monthlyProValue/totals.monthlyProTargetValue)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
                            <td>{Number(totals.totalProTargetValue)>0 ? (Number((totals.totalCumProValue/totals.totalProTargetValue)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>

                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalpreProTargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalCumPreProValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>{totals.totalpreCumProTargetValue>0 ? (Number((totals.totalCumPreProValue/totals.totalpreCumProTargetValue)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
                            <td>{Number(totals.totalCumProValue-totals.totalCumPreProValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{(Number(totals.totalCumProValue-totals.totalCumPreProValue)>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                          </tr>
                          
                          <tr className="shaded-row" style={{ border: '1px solid black'}}>
                            <td>Sales</td>
                            <td>{Number(totals.totaltargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.monthlySalesTargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalSalesTargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.monthlySalesValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalCumSalesValue).toFixed(2).toLocaleString('en-IN')}</td>
                            
                            <td>{Number(totals.monthlySalesTargetValue)>0 ? (Number((totals.monthlySalesValue/totals.monthlySalesTargetValue)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
                            <td>{Number(totals.totalSalesTargetValue)>0 ? (Number((totals.totalCumSalesValue/totals.totalSalesTargetValue)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>

                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalpreTargetValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalCumPreSalesValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>{totals.totalpreCumTargetValue>0 ? (Number((totals.totalCumPreSalesValue/totals.totalpreCumTargetValue)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
                            <td>{Number(totals.totalCumSalesValue-totals.totalCumPreSalesValue).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{(Number(totals.totalCumSalesValue-totals.totalCumPreSalesValue)>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                          </tr>

                          <tr style={{ border: '1px solid black'}}>
                            <td>Profit/Loss</td>
                            <td>{Number(totals.totalprofitTarget).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.monthlyProfitTarget).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalCumProfitTarget).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.monthlyProfitLoss).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{Number(totals.totalCumProfitLoss).toFixed(2).toLocaleString('en-IN')}</td>

                            <td>{Number(totals.monthlyProfitTarget)>0 ? (Number((totals.monthlyProfitLoss/totals.monthlyProfitTarget)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
                            <td>{Number(totals.totalCumProfitTarget)>0 ? (Number((totals.totalCumProfitLoss/totals.totalCumProfitTarget)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
                            
                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalpreProfitTarget).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>{Number(totals.totalCumPreProfitLoss).toFixed(2).toLocaleString('en-IN')}</td>
                            <td style={{backgroundColor:'pink'}}>{totals.totalpreProfitCumTarget>0 ? (Number((totals.totalCumPreProfitLoss/totals.totalpreProfitCumTarget)*100).toFixed(2).toLocaleString('en-IN')):'0'}%</td>
                            <td>{Number(totals.totalCumProfitLoss-totals.totalCumPreProfitLoss).toFixed(2).toLocaleString('en-IN')}</td>
                            <td>{(Number(totals.totalCumProfitLoss-totals.totalCumPreProfitLoss)>0)?<Icon.ArrowUp style={{ color: 'green', fontWeight: 'bold', fontSize: '16px'}}/>:<Icon.ArrowDown style={{ color: 'red', fontWeight: 'bold', fontSize: '16px'}}/>}</td>
                          </tr>
                          <tr><td colspan={14} style={{backgroundColor:'lightgreen'}}></td></tr>
                        </tbody>
                        <tfoot>
                          
                        </tfoot>
                        </table>
                        
                        </div>
                        </div>
                      </div> 
                      </>
                    )
                  }                  
                  
                </div>  

            </div>   

            {
            misDataSum && misDataSum.length >0 &&(
            <div>
              <ProSalesProfitGraph misDataSum={misDataSum}/>
            </div>
            )}

        </div>
        </>
    )
}

export default ProSalesProfitAnalysis;